import React from 'react';
import './Impressum.css';

export default function Impressum() {
    return (
        <div className="impressum-page">
            <div className="impressum-container">
                <h1>Impressum</h1>
                
                <section className="impressum-section">
                    <h2>Autohandel Schuman</h2>
                    
                    <p>Hänfligstr 10</p>
                    <p>45472 Mülheim an der Ruhr</p>
                    {/* <p>Amtsgericht Berlin-Charlottenburg, HRB XXXXXX B</p> */}
                    <p>Geschäftsführer: Ali Schuman</p>
                </section>
                
                <section className="impressum-section">
                    <h2>Kontakt:</h2>
                    <p>Telefon: 01716121034</p>
                    {/* <p>Fax: 030 / XXXX XXXX</p> */}
                    <p>E-Mail: auto-zack@hotmail.com</p>
                    <p>Website: autozack.de</p>
                </section>
                
                <section className="impressum-section">
                    {/* <p>Eingetragen im Handelsregister des Amtsgerichts Berlin-Charlottenburg unter HRB XXXXXX B</p> */}
                    <p>Umsatzsteuer-ID gemäß § 27a UStG: DE290114559</p>
                    <p>Verantwortlich für eigene Inhalte nach § 55 RStV: Ali Schuman</p>
                </section>
                
                <section className="impressum-section">
                    <h2>Streitschlichtung</h2>
                    <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr/</a></p>
                    <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
                </section>
                
                <section className="impressum-section">
                    <h2>Haftung für Inhalte / Links</h2>
                    <p>Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für externe Links. Für den Inhalt verlinkter Seiten sind ausschließlich deren Betreiber verantwortlich.</p>
                </section>

            </div>
        </div>
    );
}
